// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__hRr6g","upload":"Small_upload__1aINV","imageWrap":"Small_imageWrap__391Em","removeBtn":"Small_removeBtn__1Selt"};